import { parseHost } from '@/Domain/helper/scrapeUrlClassifier';

// Falls back to a substring on unparseable input so `url_host` stays non-null
// in PostHog (real events were landing with null and breaking funnel joins).
export function extractUrlHost(url: string): string | undefined {
  if (!url || !url.trim()) return undefined;
  const parsedHost = parseHost(url);
  if (parsedHost) return parsedHost;
  const fallback = url
    .replace(/^[a-zA-Z][a-zA-Z0-9+\-.]*:\/\//, '')
    .split(/[/?#]/, 1)[0]
    .trim()
    .toLowerCase();
  return fallback || '-invalid-';
}
